import type { ComponentType } from 'react';

import SubmitKycModal from '@features/subscription/components/SubmitKycModal';

/**
 * Maps API `custom` action `target` strings to modals/overlays opened by dynamic
 * banners or popups. Add entries here when introducing new `custom` targets.
 */
export const CUSTOM_ACTION_REGISTRY = {
  'submit-kyc-modal': SubmitKycModal
} as const;

export type CustomActionTargetId = keyof typeof CUSTOM_ACTION_REGISTRY;

export type CustomActionComponent = ComponentType<{
  onClose: () => void;
}>;

export const isRegisteredCustomTarget = (
  target: string
): target is CustomActionTargetId =>
  Object.prototype.hasOwnProperty.call(CUSTOM_ACTION_REGISTRY, target);

export const getCustomActionComponent = (
  target: string
): CustomActionComponent | undefined => {
  if (!isRegisteredCustomTarget(target)) return undefined;
  return CUSTOM_ACTION_REGISTRY[target];
};
